import axios from 'axios';
import SearchBox from 'components/common/SearchBox';
import UsersTable, { UsersTableColumns } from 'components/tables/UsersTable';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const token = localStorage.getItem('token');

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });

  useEffect(() => {
    getList();
  }, [pagination, searchQuery]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Reset to first page when search changes
      if (searchQuery !== '' && pagination.pageIndex !== 0) {
        setPagination(prev => ({ ...prev, pageIndex: 0 }));
      } else {
        getList();
      }
    }, 1000); // 1000ms debounce

    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  const getList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/users`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          page: pagination.pageIndex + 1,
          pageSize: pagination.pageSize,
          search: searchQuery || undefined
        }
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    setUsers(response.data['data']['users']);
    setTotalRecords(response.data['data']['totalRecords']);
  };

  const handleSubmit = async (id: number, comment: string, status: string) => {
    const data = { id, comment, status };
    const response = await axios.put(
      `${process.env.REACT_APP_ENDPOINT}/reward-claim-request`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }

    toast.success(response.data['message']);
    return true;
  };

  const handlePaginationChange = (updater: any) => {
    const newState =
      typeof updater === 'function' ? updater(pagination) : updater;
    setPagination(newState);
  };

  const table = useAdvanceTable({
    data: users,
    columns: UsersTableColumns,
    pageSize: pagination.pageSize,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      handleSubmit: handleSubmit,
      manualPagination: true,
      totalRecords: totalRecords,
      onPaginationChange: handlePaginationChange,
      pagination: pagination,
      getList: getList
    }
  });
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    // table.setGlobalFilter(e.target.value || undefined);
    const value = e.target.value;
    setSearchQuery(value);
  };
  return (
    <div>
      <div className="mb-6">
        <AdvanceTableProvider {...table}>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <h2 className="mb-4">{totalRecords} Users</h2>
            </Col>
            <Col xs="auto">
              <div className="d-flex">
                <SearchBox
                  placeholder="Search by username and user ID"
                  className="me-2"
                  onChange={handleSearchInputChange}
                />
              </div>
            </Col>
          </Row>
          <UsersTable />
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export default UserList;
